var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-md hover:shadow-xl rounded-xl transition-all delay-100 duration-75 min-w-80",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-100 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("header")],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "-mt-11 ml-8 p-5 z-10 my-4 flex gap-4 max-h-30 justify-end flex-col",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }